export default {
    colors: {
        primary: '#0179FE',
        secondary: '#0179FE',
        tertiary: '#8149F8'
    },
    overrideFunction: ({ colors }) => ({
        h1BorderColor: colors.primary,
        h2BorderColor: colors.primary,
        colorLink: colors.primary,
        navItemTransform: 'uppercase',
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.primary,
        partnerCardMainDiscountColor: colors.primary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black,

        partnerButtonBgColor: colors.tertiary,
        partnerButtonColor: colors.white,
        partnerButtonBorderColor: colors.tertiary
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/poulpeoTheme.js